<template>
  <div
    v-if="item.reason_code"
    class="tag tag--dark tooltip"
    v-bind:data-tooltip="item.reason_name"
  >
    <strong>{{ item.reason_code }}</strong>
  </div>
</template>
<script>
export default {
  name: "item-reason-code",
  props: {
    item: {}
  }
};
</script>
